import { Validators } from '@angular/forms';
import { AutocompleteWithControlsConfig } from '@shared/modules/autocomplete-with-controls';
import { brandModelMaxLength } from './ii-brand-model/ii-brand-model.constants';
import { NotHighlightPristineErrorStateMatcher } from '@shared/classes/not-highlight-pristine-error-state-matcher';

export const AmountIntegerPattern = /^[0-9]*$/;
export const WeightPattern = /^\d+(\.\d{1,2})?$/;

export const amountErrors = {
  required: 'Це поле обов\'язкове',
  pattern: 'Введіть ціле число',
};

export const materialsErrors = {
  required: 'Це поле обов\'язкове',
  forbiddenSymbols: 'Матеріал не може містити російську мову',
};

export const countryErrors = {
  required: 'Це поле обов\'язкове',
  manufacturerCountry: 'Оберіть країну зі списку',
};

export const configCountry: AutocompleteWithControlsConfig = {
  ariaLabel: 'Країна-виробник',
  placeholder: 'Країна-виробник',
  arrow: true,
  errorStateMatcher: new NotHighlightPristineErrorStateMatcher(),
};

export const configCurrency: AutocompleteWithControlsConfig = {
  ariaLabel: '',
  placeholder: 'Валюта вартості позиції',
  arrow: false,
  errorStateMatcher: new NotHighlightPristineErrorStateMatcher(),
};

export const configWeightUnit: AutocompleteWithControlsConfig = {
  ariaLabel: '',
  placeholder: '',
  arrow: false,
  errorStateMatcher: new NotHighlightPristineErrorStateMatcher(),
};

export const hintMessageMaterials = 'Вкажіть матеріал відправлення:\n' +
  '\n' +
  'бавовна / пластик / метал / скло / папір / силікон / …';

export const unitFloatAllowed: Record<string, boolean> = {
  kilogram: true,
  meter: true,
  package: false,
  pieces: false,
};

export const BrandModelDefaultValidators = [Validators.maxLength(brandModelMaxLength)];
